import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  modal: {
    maxWidth: "520px",
  },
}));

export default styles;
